import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { EventStreamCopySource } from 'app/model/pipeline/copysource/event-stream.copysource';
import { IModel } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(EventStreamCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts
    }
})
export class EventStreamCopySourceAdapter extends CopySourceAdapter<
    EventStreamCopySource,
    Model.CopySource
> {
    protected model(): IModel {
        return EventStreamCopySource.MODEL;
    }

    protected override async _toResource(
        copySource: EventStreamCopySource
    ): Promise<Model.CopySource> {
        return this._toTabularResource(copySource, this.model().name);
    }

    protected override async _toModel(
        resource: Model.CopySource,
        copyActivity: CopyActivity
    ): Promise<EventStreamCopySource> {
        return this._toTabularModel(
            resource,
            copyActivity,
            this.model()
        ) as EventStreamCopySource;
    }
}
